define(['app/modules/utilities'], (Utils) => {
  var Uploader = function(element, prop) {
    prop = prop || {};
    this._element = element;
    this._inputFile = element.find('input[type=file]');
    this._cacheInputFile = element.find('input.cached_file');
    this._linkElement = element.find('a') || null;
    this._uploudContent = element.find('.upload-content');
    this._button = $(this._uploudContent.find('button')[0]);
    this._additional_button = $(
      this._uploudContent.find('.additional-upload-btn')[0]
    );
    this._progressBar = this._uploudContent.find('.progress-bar');
    this._elementRemove = element.find('.destroy-file');
    this._uploudBox = element.find('.uploaded-applicants');

    this._counters = {
      uploads: 0,
      contacts: 0
    };

    this._emails = [];

    this.addApplicantItem = function(data) {
      this._emails.push(data.email);
      var _template = $('.item.applicant-uploader-item.dn');
      var template = _template.clone();
      template.removeClass('dn');
      var counters = [];
      var userId = (data.user && data.user.id) || '';
      counters.push('contacts');
      if (data.status === 'error') {
        template.addClass('error-item');
      }
      this.setFieldValue(template, 'checked', 'true');
      this.setFieldValue(template, 'email', data.email || '');
      this.setFieldValue(template, 'resume_url', data.resume_url);
      this.setFieldValue(template, 'user_id', userId);
      this.setFieldValue(template, 'email_edited', false);

      if (userId) {
        template.find('.name').removeClass('new');
        template.find('.name').html(data.user.full_name);
        if (data.user.full_photo_url) {
          template
            .find('.photo')
            .html("<img src='" + data.user.full_photo_url + "'>");
        }
      }
      template.find('.js-link').attr('href', data.resume_url);
      this._uploudBox.append(template);
      this._uploudBox
        .find('input[type=checkbox]')
        .iCheck({ handle: 'checkbox' });
      this._uploudBox.find('input[name*=email]')
        .data({ 'parsed-email': data.email });
      this.iterateCounters(counters);

      this.handleClickDocument = this.handleClickDocument.bind(this);
      this.handleSaveEmail = this.handleSaveEmail.bind(this);

      template.find('.js-email').on('click', this.handleEditEmail);
      template.find('.js-clear').on('click', this.handleClearEmail);
      template.find('.js-save').on('click', this.handleSaveEmail);
      template.find('.js-input').on('keydown', (e) => {
        if (e.which === 13) {
          e.preventDefault();
          this.handleSaveEmail(e)
        }
      });

      $(document).on('click', this.handleClickDocument);
    };

    this.iterateCounters = function(counters) {
      counters.forEach(counter_name => {
        this._counters[counter_name] += 1;
        this._element
          .find(`.item-${counter_name} .count`)
          .html(this._counters[counter_name]);
      });
    };

    this.resetCounters = function() {
      ['uploads', 'contacts'].forEach(counter_name => {
        this._counters[counter_name] = 0;
        this._element
          .find(`.item-${counter_name} .count`)
          .html(this._counters[counter_name]);
      });
    };

    this.setFieldValue = function(template, field_name, value) {
      template.find('input[name=' + field_name + ']').attr({
        name: 'applicant_upload[cvs_attributes][][' + field_name + ']',
        value: value
      });
    };

    this.resetUploader = function() {
      this._uploudBox.empty();
      this.resetCounters();
      this._emails = [];
    };

    this._acceptFileTypes = /(\.|\/)(pdf|doc|docx|rtf|txt)$/i;
    this._button.text('Upload CVs files');

    this._button.on('click', $.proxy(this._onClick, this));
    this._additional_button.on('click', $.proxy(this._onClick, this));
    this._elementRemove.on('click', $.proxy(this._onClickRemove, this));
    $(document).bind('dragover', $.proxy(this._onDragOver, this));

    if (prop.autoUpload != undefined) this._autoUpload = prop.autoUpload;

    this.initFileupload();
  };

  Uploader.prototype.handleEditEmail = function(event) {
    var $target = $(event.currentTarget);
    var $input = $target.find('input');

    $target.addClass('active');
    $input
      .attr('readonly', false)
      .data({ email: $input.val() })
      .focus();
  };

  Uploader.prototype.handleClearEmail = function(event) {
    var $target = $(event.currentTarget);
    var $el = $target.parents('.js-email');
    var $input = $el.find('.js-input');

    $input.val('').focus();
    event.stopPropagation();
  };

  Uploader.prototype.handleSaveEmail = function(event) {
    event.stopPropagation();

    var $target = $(event.currentTarget);
    var $el = $target.parents('.js-email');
    var $input = $el.find('.js-input');

    this.checkEmail($el, $input);
  };

  Uploader.prototype.checkEmail = function($el, $input) {
    var email = $input.val();
    $parent = $el.parents('.applicant-uploader-item');
    var prevEmail = $input.data('email');
    var parsedEmail = $input.data('parsed-email');

    if (Utils.validateEmail(email)) {
      $parent.removeClass('error-item');
      $el.removeClass('active error-shake');

      this._emails = this._emails.map(
        currentEmail => (currentEmail === prevEmail ? email : currentEmail)
      );

      $parent.find('input[name*=email_edited]').val(parsedEmail !== email);

      return $input.attr('readonly', true);
    }

    $el.addClass('error-shake');
  };

  Uploader.prototype.handleClickDocument = function(event) {
    var $target = $(event.target);

    if (!$target.closest('.js-email').length) {
      var $el = this._element.find('.js-email');
      var self = this;

      $el.each(function(idx, el) {
        var $el = $(el);
        var $input = $el.find('.js-input');

        self.checkEmail($el, $input);
      });
    }
  };

  Uploader.prototype._element = null;
  Uploader.prototype._inputFile = null;
  Uploader.prototype._cacheInputFile = null;
  Uploader.prototype._dropZoneTimeout = null;
  Uploader.prototype._uploudContent = null;
  Uploader.prototype._button = null;
  Uploader.prototype._progressBar = null;
  Uploader.prototype._maxFileSize = 10 * 1024 * 1024; //10Mb
  Uploader.prototype._reqFileTypes = /(\.|\/)([a-z]{2,3})$/i;
  Uploader.prototype._acceptFileTypes = /(\.|\/)(pdf|doc|docx|rtf|txt)$/i;
  Uploader.prototype._isFileuploadstart = false;
  Uploader.prototype._autoUpload = true;

  Uploader.prototype.initFileupload = function() {
    var that = this;
    var originalAdd = $.blueimp.fileupload.prototype.options.add;

    this._uploudContent
      .fileupload({
        dataType: 'json',
        type: 'PUT',
        url: this._inputFile.data('url'),
        dropZone: this._uploudContent,
        autoUpload: this._autoUpload,
        fileInput: this._inputFile,
        fileInputClone: false,
        limitMultiFileUploads: 1,
        add: function(e, data) {
          var file = data.files[0];
          that._isFileuploadstart = true;

          if (
            file &&
            that._acceptFileTypes.test(file.name) &&
            file.size < that._maxFileSize
          ) {
            data.data = new FormData();
            data.data.append('upl_file', file);

            if (that._autoUpload) originalAdd.call(this, e, data);
            else {
              //NOTE: old school style
              var obj = that._element.find('input[type=file]')[0];
              var parent = obj.parentNode;
              parent.replaceChild(that._inputFile[0], obj);
            }
          } else {
            if (data.fileInputClone) {
              that._inputFile = data.fileInputClone;
            }
            that._inputFile.val('');
            that._uploudContent
              .removeClass('upload-progress upload-done upload-remove')
              .addClass('upload-error');
          }
        },
        progressall: $.proxy(function(e, data) {
          var progress = parseInt((data.loaded / data.total) * 100, 10);
          this._progressBar.css('width', progress + '%');
        }, this)
      })
      .bind(
        'fileuploadstart',
        $.proxy(function(e, data) {
          this._uploudContent.addClass('upload-progress');
          this._isFileuploadstart = true;
        }, this)
      )
      .bind('fileuploadprogress', function(e, data) {})
      .bind('fileuploaddone', $.proxy(this._onFileuploaddone, this))
      .bind('fileuploadchange', $.proxy(this._onFileuploadchange, this))
      .bind('fileuploadfail', $.proxy(this._onFileUploadFail, this));
  };

  Uploader.prototype._onFileuploadchange = function(ev, data) {
    if (this._autoUpload) return;
    this._uploudContent
      .removeClass('upload-progress upload-done upload-error')
      .addClass('upload-file');
  };

  Uploader.prototype._onFileuploaddone = function(ev, data) {
    this._uploudContent
      .removeClass('upload-progress upload-error')
      .addClass('hideable-active');
    this._progressBar.css('width', 0);

    if (data.fileInputClone) {
      this._inputFile = data.fileInputClone;
    }
    this._inputFile.val('');
    var res = data.result;
    this._uploudContent.removeClass('upload-progress upload-done upload-error');
    this._uploudContent.addClass('upload-file');
    this.iterateCounters(['uploads']);
    if (!res.email || (res.email && !this._emails.includes(res.email))) {
      this.addApplicantItem(res);
    }
    this._isFileuploadstart = false;
  };

  Uploader.prototype._onFileUploadFail = function(ev, data) {
    this._uploudContent
      .removeClass('upload-progress upload-done')
      .addClass('upload-error');
    this._isFileuploadstart = false;
  };

  Uploader.prototype._onDragOver = function(ev) {
    if (!this._dropZoneTimeout) {
      if (this._uploudContent.hasClass('upload-remove')) {
        this._imgElement.hide();
      }
      this._uploudContent.removeClass(
        'upload-progress upload-done upload-error upload-remove'
      );
    } else {
      clearTimeout(this._dropZoneTimeout);
    }

    var found = false,
      node = ev.target;
    do {
      if (node === this._uploudContent[0]) {
        found = true;
        break;
      }
      node = node.parentNode;
    } while (node != null);
    if (found) {
      this._uploudContent.addClass('drop-hover');
    } else {
      this._uploudContent.removeClass('drop-hover');
    }
    this._dropZoneTimeout = setTimeout(
      $.proxy(function() {
        this._dropZoneTimeout = null;
      }, this),
      100
    );
  };

  Uploader.prototype._onClick = function(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    this._uploudContent.removeClass('upload-error');

    this._inputFile.click();
  };

  Uploader.prototype._onClickRemove = function(ev) {
    ev.preventDefault();
    var url = this._inputFile.data('destroy-url');

    if (url) {
      var that = this;

      $.ajax({
        type: 'PUT',
        url: url,
        success: function(result) {
          if (result.status == 'ok') {
            that._linkElement = null;
            that._uploudContent.removeClass('upload-file');
          }
        }
      });
    }
  };

  return Uploader;
});
